import React from "react";
import { useRouter } from "next/router";
import dynamic from "next/dynamic.js";
import { isObjectNotEmpty } from "src/helpers/functions.js";
const PageHeader = dynamic(() =>
  import("src/components/shared/PageHeader/PageHeader")
);
const BreadCrumb = dynamic(() =>
  import("src/components/shared/breadCrumb/Index.js")
);
const BlogDetails = dynamic(() => import("./BlogDetails.jsx"));
const Footer = dynamic(() => import("src/components/shared/Footer/Footer"));

const SingleBlog = ({ data }) => {
  const { singleBlogData } = data;
  const { locale } = useRouter();
  const renderSingleBlog = () => {
    if (singleBlogData && isObjectNotEmpty(singleBlogData)) {
      return <BlogDetails singleBlogData={singleBlogData} />;
    }
  };
  return (
    <div>
      <PageHeader />
      <BreadCrumb
        title={
          singleBlogData?.title?.[locale].length > 100
            ? `${singleBlogData?.title?.[locale].slice(0, 100)}...`
            : `${singleBlogData?.title?.[locale].slice(0, 100)}`
        }
      />
      {renderSingleBlog()}
      <Footer />
    </div>
  );
};

export default SingleBlog;
